import { useState } from 'react'
import { filterOperationsTree } from '@sportninja/common/features/competition/operations/utils/filterOperationsTree'
import type { OperationsNode } from '@sportninja/common/features/competition/operations/types/operations.types'

export interface TreeSearch {
  term: string
  setTerm: (term: string) => void
  nodes: OperationsNode[]
  matchCount: number
  matchedIds: Set<string>
  isSearching: boolean
}

/**
 * Owns the rail's search term and derives the filtered tree from it. Filtering
 * is in-place: ancestors of a match are kept so the hierarchy never collapses
 * under the user.
 */
export const useTreeSearch = (nodes: OperationsNode[]): TreeSearch => {
  'use memo'

  const [term, setTerm] = useState('')
  const {
    nodes: filtered,
    matchCount,
    matchedIds,
  } = filterOperationsTree(nodes, term)

  return {
    term,
    setTerm,
    nodes: filtered,
    matchCount,
    matchedIds,
    isSearching: term.trim().length > 0,
  }
}
